import moment from 'moment';
import {i18n} from 'src/i18n';
import layoutActions from 'src/modules/layout/layoutActions';
import Errors from 'src/modules/shared/error/errors';
import {getHistory} from 'src/modules/history';
import TerceroService from 'src/modules/tercero/terceroService';
import Message from 'src/view/shared/message';
import terceroListActions from '../list/terceroListActions';

const prefix = 'TERCERO_FORM';

const terceroFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: terceroFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await TerceroService.find(id);
      }

      dispatch({
        type: terceroFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: terceroFormActions.INIT_ERROR,
      });

      getHistory().push('/tercero');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: terceroFormActions.CREATE_STARTED,
      });

      await TerceroService.create(values);

      dispatch({
        type: terceroFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.tercero.create.success'));

      // getHistory().push('/tercero');

      dispatch(terceroListActions.doFetchCurrentFilter());

      layoutActions.doVisibleDrawer({
        drawerId: 'DrawerTerceroFormPage',
        drawerVisible: false,
        drawerChanged: moment().unix(),
        drawerUpdateComponent: null,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: terceroFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: terceroFormActions.UPDATE_STARTED,
      });

      await TerceroService.update(id, values);

      dispatch({
        type: terceroFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.tercero.update.success'));

      // getHistory().push('/tercero');
      dispatch(terceroListActions.doFetchCurrentFilter());

      layoutActions.doVisibleDrawer({
        drawerId: 'DrawerTerceroFormPage',
        drawerVisible: false,
        drawerChanged: moment().unix(),
        drawerUpdateComponent: null,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: terceroFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default terceroFormActions;
